module.exports = __webpack_public_path__ + "img/icone-ordem-texto-menor.54463751.svg";